import React from "react"
import { ScrollReveal } from "../ui/scroll-reveal"

export function IntroSection() {
  return (
    <>
      <ScrollReveal>
        <div className="max-w-3xl mx-auto text-center space-y-4 mb-12">
          <p className="text-lg text-muted-foreground">
            At Syllepsis, we measure success by tangible outcomes. Our structured approach helps organisations achieve measurable improvements in operational efficiency, strategic clarity and accelerated delivery - within weeks, not months.
          </p>
        </div>
      </ScrollReveal>
      
      <ScrollReveal>
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h3 className="text-2xl font-semibold">Here's what our clients have to say</h3>
        </div>
      </ScrollReveal>
    </>
  )
} 